import { io, Socket } from "socket.io-client";
import * as handlers from "./model";

let socket: Socket | null = null;

export const connectWS = (token: string, userId: string): Promise<Socket> => {
  return new Promise((resolve) => {
    if (socket && socket.connected) return resolve(socket);

    socket = io("https://msg-dev.factfactor.ru", {
      path: "/socket.io",
      transports: ["websocket"],
      auth: { token },
      reconnection: true,
      reconnectionAttempts: 20,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
    });

    socket.on("message:sended", (data) => handlers.handleMessageSended(data, userId));
    socket.on("message:delived-result", handlers.handleMessageDeliveredResult);
    socket.on("message:readed-result", handlers.handleMessageReadedResult);
    socket.on("message:delete-result", handlers.handleMessageDeleteResult);
    socket.on("message:update-result", handlers.handleMessageUpdateResult);
    socket.on("error:validation", handlers.handleErrorValidation);
    socket.on("user:new-online-status", handlers.handleUserOnlineStatus);
    socket.on("disconnect", handlers.handleDisconnect);
    socket.on("connect_error", handlers.handleConnectError);

    socket.on("connect", () => {
      if (socket) resolve(socket);
    });
  });
};

export const getSocket = (): Socket | null => socket;

export const sendWSMessage = (type: string, payload: any) => {
    if (socket && socket.connected) {
      socket.emit(type, payload);
    } else if (socket) {
      // отложенная отправка после подключения
      socket.once("connect", () => socket?.emit(type, payload));
    } else {
      console.warn("Socket not initialized yet");
    }
  };
  
